import { render, staticRenderFns } from "./OrganizationEditor.vue?vue&type=template&id=547a3b5c"
import script from "./OrganizationEditor.vue?vue&type=script&lang=ts"
export * from "./OrganizationEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports